import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import api from '@/lib/api';

const JobsContext = createContext({ jobs: [], activeCount: 0, refresh: () => {} });

export const useJobs = () => useContext(JobsContext);

export const JobsProvider = ({ children }) => {
  const [jobs, setJobs] = useState([]);
  const [activeCount, setActiveCount] = useState(0);
  const timerRef = useRef(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem('ff_token')) return;
    try {
      const res = await api.get('/activity/jobs', { params: { _t: Date.now() } });
      setJobs(res.data.jobs || []);
      setActiveCount(res.data.active_count || 0);
    } catch (e) { /* silent */ }
  }, []);

  useEffect(() => {
    refresh();
    timerRef.current = setInterval(refresh, 4000);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [refresh]);

  return (
    <JobsContext.Provider value={{ jobs, activeCount, refresh }}>
      {children}
    </JobsContext.Provider>
  );
};
